import { Heading } from '@blockanalitica/ui';
import GlossaryLine from './GlossaryLine';

export default function RestrictedSection() {
  // @ts-ignore
  if (import.meta.env.VITE_PUBLIC_RESTRICTED_BUILD === 'true') {
    return null;
  }

  return (
    <>
      <Heading size="2" paddingTop="m" paddingBottom="2xs">
        Rewards and Savings
      </Heading>

      <GlossaryLine title="Rewards TVL">
        The dollar-denominated value of assets deployed towards Sky Farms.
      </GlossaryLine>
      <GlossaryLine title="Savings TVL / Total Deposits">
        The total amount of USDS and DAI in the SSR and DSR.
      </GlossaryLine>

      <GlossaryLine title="Sky Token Rewards (STRs) - SKY">
        Supply USDS to get Sky Token Rewards in the form of SKY.
      </GlossaryLine>
      <GlossaryLine title="Sky Token Rewards (STRs) - Chronicle">
        Supply USDS to gain Chronicle points.
      </GlossaryLine>
      <GlossaryLine title="Savings TVL">
        The total amount of USDS and DAI deposited into the SSR and DSR.
      </GlossaryLine>
      <GlossaryLine title="Dai Savings Rate (DSR)">
        The rate paid to DAI holders who have deposited DAI into the Dai Savings
        Rate contract.
      </GlossaryLine>
      <GlossaryLine title="Sky Savings Rate (SSR)">
        The rate paid to USDS holders who have deposited USDS into the USDS
        Savings Rate contract.
      </GlossaryLine>
      <GlossaryLine title="DAI in DSR">
        The amount of DAI supplied to the Dai Savings Rate contract.
      </GlossaryLine>
      <GlossaryLine title="USDS in SSR">
        The amount of USDS supplied to the Sky Savings Rate contract.
      </GlossaryLine>
      <GlossaryLine title="Savings USDS">
        A tokenized implementation of the Sky Savings Rate (sUSDS).
      </GlossaryLine>
      <GlossaryLine title="Seal Rewards">
        Users who Seal their MKR receive Seal Rewards in the form of USDS. In
        the future, subject to Sky Governance approval, Seal Rewards may also be
        available in the form of Sky Star tokens, including Spark’s SPK.
      </GlossaryLine>
    </>
  );
}
